import type { MfoDealOffer, TMfoDealViewModel } from 'commonTypes/api/scenarios/CreditSelectionScreenContent';

import type { sendEventOnClickMfoDealOfferOnMplCreditSelectionScreen } from 'shared/lib/sendGAEvents';

import { getAnalyticsMfoDealOfferParams } from './getAnalyticsMfoDealOfferParams';
import type { TCommonMplAnalyticsParams } from './getCommonMplAnalyticsParams';

export const getAnalyticsOnClickMfoDealOfferData = (
  commonMplAnalyticsParams: TCommonMplAnalyticsParams,
  deal: TMfoDealViewModel,
  offer: MfoDealOffer,
): Parameters<typeof sendEventOnClickMfoDealOfferOnMplCreditSelectionScreen>[0] => ({
  ...commonMplAnalyticsParams,
  ...getAnalyticsMfoDealOfferParams(deal, offer),
});
